export default {
  // Date formatting
  'date.format': 'dd.MM.yyyy',
  'date.format_datetime': 'dd.MM.yyyy HH:mm',
  'date.format_datetime_long': "EEEE, d. MMMM yyyy 'um' HH:mm 'Uhr'",

  language: 'Sprooch',
  sign_out: 'Abmälde',
  sign_in: 'Amälde',
  email_address: 'E-Mail Adrässe',
  'login.title': 'Mit Dim {app}-Konto amälde',
  'login.remember_me': 'Agmäldet blibe',
  'login.password_placeholder': 'Dis Passwort',
  'nav.home': 'Dahei',
  'nav.orders': 'Ufträg',
  'nav.active_poolmirror_campaign': 'Portfolio Kampagne',
  'nav.cvanalyzer': 'Lebenslauf Compi',
  'nav.external_job_markets': 'Stelle',
  'home.see_all_orders': 'Alli Ufträg aaluege',
  'home.see_all_orders_heading': 'Lueg doch Dim Uftrag!',
  'home.see_all_orders_subheading': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
  'home.create_order': 'Neua Uftrag',
  'home.create_order_heading': 'Hesch no kei Uftrag?',
  'home.create_order_subheading': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed',
  'portfolio.crawled_jobs': 'Gecrawlti Stelle',
  'portfolio.campaign_slots': 'Kampagne Slots',
  'portfolio.slot_usage': 'Slot Uslastig',
  'portfolio.subscription': 'Abo',
  'portfolio.subscription_ends_in': 'Endet',
  'portfolio.available_jobs': 'Verfüegbari Stellenaazeige',
  'portfolio.show_all_slots': 'Alli Slots aaluege',
  'portfolio.job_search_placeholder': '"/" zum Stelle sueche',
  'search.generic_placeholder': 'Drück "/" zum sueche',
  'orders.search_placeholder': 'Ufträg, Uftrags-IDs, Firmene sueche...',
  'cvanalyzer.list.title': 'Verarbeiteti Läbenslouf',
  'is_loading.generic': 'Date werde glade...',
  'sort.direction': 'Sortierigsrichtig',
  'sort.field.created_at': 'Erstelligsdatum',
  'sort.field.relevance': 'Relevanz',
  'orders.list.sort.title': 'Uftragstitel',
  'orders.list.column.order': 'Uftrag',
  'orders.list.column.runtime': 'Laufzyt',
  'orders.list.column.budget': 'Budget',
  'orders.grid.last_7_days': 'Letschti 7 Täg',
  'orders.grid.clicks_ctr': 'Klicks · CTR',
  'orders.details.open': 'Öffne',
  'btn.more': 'Meh',
  'orders.layout.list': 'Lischt',
  'orders.layout.grid': 'Gitter',
  'orders.list.title': 'Ufträg',
  'orders.list.subtitle.singular': 'Uftrag',
  'orders.list.subtitle.plural': 'Ufträg',
  'orders.list.loading': 'Diini Ufträg werded glade..',
  'orders.list.filter_label': 'Filter',
  'orders.list.filter_all': 'Alle ufträg',
  'orders.list.filter_active': 'Activ ufträge',
  'orders.list.filter_drafts': 'Entwürf',
  'orders.list.filter_past': 'Vergangene ufträge',
  'orders.list.filter_my': 'Meine ufträge',
  'orders.list.empty.active.title': 'Nonig activ ufträg',
  'orders.list.empty.active.body':
    'Diini nöchsti Iistellig isch nur en Uftrag entfernt. Starte en neue oder mach en Entwurf oder alte Uftrag under „Alle" uf.',
  'orders.list.empty.active.go_to_all': 'Zu „Alle"',
  'orders.create_button': 'Uftrag erstelle',
  'orders.list.total_clicks': 'Klicks',
  'orders.list.impressions': 'Impressione',
  'orders.list.days': 'Täg',
  'orders.list.worldwide': 'Wältwiit',
  'orders.pagination.page': 'Siite',
  'orders.pagination.prev': 'Vorherig',
  'orders.pagination.next': 'Nächschti',
  'pagination.of': 'vo',
  'pagination.nav': 'Siite-Navigation',
  'pagination.first': 'Erschti Siite',
  'pagination.prev': 'Vorherigi Siite',
  'pagination.next': 'Nächschti Siite',
  'pagination.last': 'Letschti Siite',
  'orders.filters.company_name': 'Unternehme',
  'orders.filters.creator': 'Creator',
  'orders.filters.location': 'Arbeitsort',
  'orders.filters.language': 'Sprooch',
  'language.de': 'Dütsch',
  'language.en': 'Änglisch',
  'language.fr': 'Französisch',
  'language.it': 'Italiänisch',
  'orders.filters.reset_filters': 'Zruggsetze',
  'orders.filters.apply': 'Aawände',
  'common.of': 'vo',
  'common.close': 'Schliesse',
  'customer.cards.settings.title': 'Box-Iistellige',
  'customer.cards.settings.metric_label': 'Metrik',
  'customer.cards.settings.metric_placeholder': 'Bitte uuswähle...',
  'common.active': 'Aktiv',
  'common.inactive': 'Inaktiv',
  'common.expired': 'Abgloffe',
  'common.new': 'Neu',

  'order.status.draft': 'Entwurf',
  'order.status.to_be_confirmed': 'Warte uft Beschtätigung',
  'order.status.confirmed': 'Beschtätigt',
  'order.status.running': 'Aktiv',
  'order.status.finished': 'Abgschlosse',

  // External Job Markets
  'external_job_markets.title': 'Stelle',
  'external_job_markets.jobs_count': 'Jobs',
  'external_job_markets.last_updated': 'Aktualisiert',
  'external_job_markets.select_datapool': 'Wähl e Jobbörse uus',
  'external_job_markets.select_datapool_hint': 'Wähl eini vo de verfüegbare Jobbörse uus, zum d Jobs azzeige',
  'external_job_markets.jobs_for_datapool': 'Jobs für {name}',
  'external_job_markets.search_jobs': 'Jobs sueche',
  'external_job_markets.job_title': 'Jobtitel',
  'external_job_markets.company': 'Undernehme',
  'external_job_markets.location': 'Standort',
  'external_job_markets.workload': 'Arbeitspänsli',
  'external_job_markets.language': 'Sprach',
  'external_job_markets.expires': 'Lauft ab',
  'external_job_markets.view_job': 'Job azeige',
  'external_job_markets.create_order': 'Uftrag erstelle',
  'external_job_markets.no_jobs': 'Kei Jobs gfunde',
  'external_job_markets.no_jobs_search': 'Kei Jobs für dyni Suechi gfunde',
  'external_job_markets.no_jobs_hint': 'Die Jobbörse het momemals kei aktive Jobs',
  'external_job_markets.expires_soon': 'Lauft bald ab',
  'external_job_markets.expired': 'Abgloffe',
  'external_job_markets.no_applications': 'Kei Bewerbige',
  'external_job_markets.no_hires': 'Kei Istellige',
  'external_job_markets.not_enough_applications': 'Z wenig Bewerbige',
  'external_job_markets.filters': 'Filter',
  'external_job_markets.freshness': 'Aktualität',
  'external_job_markets.freshness.today': 'Letscht 24h',
  'external_job_markets.freshness.7days': 'Letscht 7 Täg',
  'external_job_markets.freshness.30days': 'Letscht 30 Täg',
  'external_job_markets.reset_filters': 'Filter zruggsetze',
  'external_job_markets.loading_jobs': 'Jobs wärde glade...',
  'external_job_markets.job_count_info': '{filtered} vo {total} Jobs',
  'external_job_markets.property_filters': 'Eigenschafte',
};
